// Переход из таблицы пополнений: вкладка открывается сразу с поиском по ID заказа.
// Компонент должен иметь filterType / searchInput / filterUser(), как остальные таблицы.
export default {
  methods: {
    applyPendingOrderSearch() {
      const orderId = this.$store.state.pendingOrderSearch;
      if (!orderId) return false;

      this.$store.state.pendingOrderSearch = null;
      this.filterType = "order id";
      this.searchInput = orderId;
      this.filterUser();
      return true;
    }
  }
};
